export default "__VITE_ASSET__Dl8BH2tO__"